export default {
  name: 'dashify:GridLayout',
  title: 'GridLayout',
  owner: 'System',
  solution: '',
  tags: ['DASHUI'],
  createdAt: 'Aug 22, 2023, 12:00 PM',
  updatedAt: 'Oct 12, 2023, 09:03 AM',
  spec: {
    props: {},
    defaults: {
      className: 'layout',
      width: 1200,
      cols: 12,
      rowHeight: 45,
      containerPadding: [10, 10],
      margin: [10, 10],
    },
    view: [['dashify:RGLGridLayout', '/${ $defaultsDeep({}, props, defaults) }', '/${ children }']],
  },
};
